import OkkoPromoMC from './views/okkoPromoMC.c.js';
export default OkkoPromoMC;
